import { render, staticRenderFns } from "./SendInvite.vue?vue&type=template&id=bbc9f89a&scoped=true&"
import script from "./SendInvite.vue?vue&type=script&lang=js&"
export * from "./SendInvite.vue?vue&type=script&lang=js&"
import style0 from "./SendInvite.vue?vue&type=style&index=0&id=bbc9f89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc9f89a",
  null
  
)

export default component.exports